<template>
  <v-form ref="reasForm" v-model="reasFormValid" lazy-validation>
    <div id="pass35">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">{{ selectedLang.ReasonTile95 }}</h2>
          </div>
        </v-col>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2">{{ selectedLang.ReasonTile96 }}</h2>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <template v-if="kiofCla == 'L'">
              <v-col cols="12" sm="6">
                <p>
                  {{
                    formatDBText(selectedLang.ReasonTile97, {
                      synFludUnR: synFludUnR,
                    })
                  }}
                </p>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select attach v-model="selectedInfoCrew" :items="itemsJN"
                  :disabled="selectedInfoCrew.val == 'y' || pass35" item-text="state" :label="selectedLang.ReasonTile99"
                  :rules="[(v) => !!v || selectedLang.ReasonTile97a + '']" :required="kiofCla == 'L'" persistent-hint
                  return-object single-line></v-select>
              </v-col>
            </template>
          </v-row>

          <v-row v-if="selectedInfoCrew.val == 'n' || kiofCla != 'L'">
            <v-col cols="12" sm="6">
              <p>
                {{
                  formatDBText(selectedLang.ReasonTile101, {
                    synFludUnR: synFludUnR,
                  })
                }}
              </p>
            </v-col>

            <v-col cols="12" sm="6">
              <v-select attach v-model="selectedInfoAirline" :items="itemsJN"
                :disabled="selectedInfoAirline.val == 'y' || pass35" item-text="state"
                :label="selectedLang.ReasonTile103" :required="selectedInfoCrew.val == 'n' || kiofCla != 'L'"
                :rules="[(v) => !!v || selectedLang.ReasonTile97a + '']" persistent-hint return-object
                single-line></v-select>
            </v-col>
          </v-row>

          <v-row v-if="selectedInfoAirline.val == 'n'">
            <v-col cols="12" sm="6">
              <p>
                {{
                  formatDBText(selectedLang.ReasonTile105, {
                    synFludUnR: synFludUnR,
                  })
                }}
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select attach v-model="selectedInfoOther" :items="itemsJN"
                :disabled="selectedInfoOther.val == 'y' || pass35" item-text="state" :label="selectedLang.ReasonTile107"
                :required="selectedInfoAirline.val == 'n'" :rules="[(v) => !!v || selectedLang.ReasonTile97a + '']"
                persistent-hint return-object single-line></v-select>
            </v-col>
          </v-row>

          <v-row v-if="showSpecRes">

            <template v-if="kiofCla != 'NB'">
              <v-col cols="12" sm="6">
                <p>
                  {{
                    formatDBText(selectedLang.ReasonTile113, {
                      synFludUnR: synFludUnR,
                    })
                  }}
                </p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select attach v-model="reasonVal" :items="caseReason" :disabled="pass35" item-text="val"
                  :label="labelSL" :required="showSpecRes && kiofCla != 'NB'"
                  :rules="[(v) => !!v || selectedLang.ReasonTile113a + '']" persistent-hint return-object
                  single-line></v-select>
              </v-col>
              <v-col v-if="needMoreRes" cols="12" sm="6">
                <p>
                  {{
                    formatDBText(selectedLang.ReasonTile114, {
                      synFludUnR: synFludUnR,
                    })
                  }}
                </p>
              </v-col>
              <v-col v-if="reasonVal.state == 'technik'" cols="12" sm="6">
                <v-select attach v-model="problemlayerzwei" :items="caseTecReason" :disabled="pass35" item-text="val"
                  :label="formatDBText(selectedLang.ReasonTile116, {
                    synFludUnR: synFludUnR,
                  })
                    " :required="reasonVal.state == 'technik'"
                  :rules="[(v) => !!v || selectedLang.ReasonTile114a + '']" persistent-hint return-object
                  single-line></v-select>
              </v-col>
              <v-col v-if="reasonVal.state == 'umwelt'" cols="12" sm="6">
                <v-select attach v-model="problemlayerzwei" :items="caseNatReason" :disabled="pass35" item-text="val"
                  :label="formatDBText(selectedLang.ReasonTile118, {
                    synFludUnR: synFludUnR,
                  })
                    " :required="reasonVal.state == 'umwelt'" :rules="[(v) => !!v || selectedLang.ReasonTile114a + '']"
                  persistent-hint return-object single-line></v-select>
              </v-col>
              <v-col v-if="reasonVal.state == 'orga'" cols="12" sm="6">
                <v-select attach v-model="problemlayerzwei" :items="caseOrgReason" :disabled="pass35" item-text="val"
                  :label="formatDBText(selectedLang.ReasonTile120, {
                    synFludUnR: synFludUnR,
                  })
                    " :required="reasonVal.state == 'orga'" :rules="[(v) => !!v || selectedLang.ReasonTile114a + '']"
                  persistent-hint return-object single-line></v-select>
              </v-col>
              <v-col v-if="reasonVal.state == 'personal'" cols="12" sm="6">
                <v-select attach v-model="problemlayerzwei" :items="casePerReason" :disabled="pass35" item-text="val"
                  :label="formatDBText(selectedLang.ReasonTile122, {
                    synFludUnR: synFludUnR,
                  })
                    " :required="reasonVal.state == 'personal'"
                  :rules="[(v) => !!v || selectedLang.ReasonTile114a + '']" persistent-hint return-object
                  single-line></v-select>
              </v-col>
              <v-col v-if="reasonVal.state == 'luftsperrung'" cols="12" sm="6">
                <v-select attach v-model="problemlayerzwei" :items="caseTraReason" :disabled="pass35" item-text="val"
                  :label="formatDBText(selectedLang.ReasonTile124, {
                    synFludUnR: synFludUnR,
                  })
                    " :required="reasonVal.state == 'luftsperrung'"
                  :rules="[(v) => !!v || selectedLang.ReasonTile124a + '']" persistent-hint return-object
                  single-line></v-select>
              </v-col>
            </template>

            <v-col cols="12" v-if="problemlayerzwei != '' || kiofCla == 'NB'">
              <p>
                {{
                  formatDBText(selectedLang.ReasonTile126, {
                    synFludUnR: synFludUnR,
                  })
                }}
              </p>
            </v-col>
            <v-col cols="12" v-if="needSpecText">
              <v-textarea name="input-7-1" filled :label="labelDR" auto-grow :disabled="pass35" :required="needSpecText"
                :rules="[(v) => !!v || selectedLang.ReasonTile114a + '']" value="" v-model="textReason"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row v-if="selectedDiv == '35'">
            <v-col cols="12">
              <v-btn :loading="loading" id="confirm-reas" block :disabled="pass35" class="btn-ep-next-step"
                @click="check35()">{{
                  selectedLang.ReasonTile129 }}</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="selectedDiv != '35' && !noChange">
            <v-col cols="12">
              <v-btn id="goto--reas" block class="btn-ep-back-to" @click="backToSpecificTile('35')">{{
                selectedLang.ReasonTile130 }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import dayjs from "dayjs";
export default {
  name: "ReasonTile",
  data: function () {
    return {
      textReason: "",
      reasonVal: "",
      problemlayerzwei: "",
      reasFormValid: false,
      loading: false,
      caseReason: [
        {
          state: "technik",
          val: this.$store.state.selectedLang.ReasonTile2,
          poss: true,
        },
        {
          state: "luftsperrung",
          val: this.$store.state.selectedLang.ReasonTile4,
          poss: false,
        },
        {
          state: "umwelt",
          val: this.$store.state.selectedLang.ReasonTile6,
          poss: false,
        },
        {
          state: "personal",
          val: this.$store.state.selectedLang.ReasonTile8,
          poss: true,
        },
        {
          state: "orga",
          val: this.$store.state.selectedLang.ReasonTile10,
          poss: true,
        },
        {
          state: "streik",
          val: this.$store.state.selectedLang.ReasonTile12,
          poss: true,
        },
        {
          state: "streik",
          val: this.$store.state.selectedLang.ReasonTile12a,
          poss: false,
        },
        {
          state: "corona",
          val: this.$store.state.selectedLang.ReasonTile14,
          poss: false,
        },
        {
          state: "blitz",
          val: this.$store.state.selectedLang.ReasonTile16,
          poss: false,
        },
        {
          state: "vogel",
          val: this.$store.state.selectedLang.ReasonTile18,
          poss: false,
        },
        {
          state: "anderes",
          val: this.$store.state.selectedLang.ReasonTile20,
          poss: true,
        },
      ],
      caseTecReason: [
        {
          state: "defekt",
          val: this.$store.state.selectedLang.ReasonTile22,
          poss: true,
        },
        {
          state: "blitzschlag",
          val: this.$store.state.selectedLang.ReasonTile24,
          poss: false,
        },
        {
          state: "vogelschlag",
          val: this.$store.state.selectedLang.ReasonTile26,
          poss: false,
        },
        {
          state: "boden",
          val: this.$store.state.selectedLang.ReasonTile28,
          poss: false,
        },
        {
          state: "flugsicherung",
          val: this.$store.state.selectedLang.ReasonTile30,
          poss: false,
        },
        {
          state: "stromausfall",
          val: this.$store.state.selectedLang.ReasonTile32,
          poss: false,
        },
        {
          state: "sabotage",
          val: this.$store.state.selectedLang.ReasonTile34,
          poss: false,
        },
        {
          state: "unbekannt",
          val: this.$store.state.selectedLang.ReasonTile36,
          poss: true,
        },
        {
          state: "anderes",
          val: this.$store.state.selectedLang.ReasonTile38,
          poss: true,
        },
      ],
      caseNatReason: [
        {
          state: "sichgefwetter",
          val: this.$store.state.selectedLang.ReasonTile40,
          poss: false,
        },
        {
          state: "nebel",
          val: this.$store.state.selectedLang.ReasonTile42,
          poss: false,
        },
        {
          state: "mangelschneeraeumung",
          val: this.$store.state.selectedLang.ReasonTile44,
          poss: false,
        },
        {
          state: "nkatastrophe",
          val: this.$store.state.selectedLang.ReasonTile46,
          poss: false,
        },
        {
          state: "blitz",
          val: this.$store.state.selectedLang.ReasonTile48,
          poss: false,
        },
        {
          state: "vogel",
          val: this.$store.state.selectedLang.ReasonTile50,
          poss: false,
        },
        {
          state: "insekt",
          val: this.$store.state.selectedLang.ReasonTile52,
          poss: false,
        },
      ],
      caseOrgReason: [
        {
          state: "personalflughafen",
          val: this.$store.state.selectedLang.ReasonTile54a,
          poss: false,
        },
        {
          state: "softwarairport",
          val: this.$store.state.selectedLang.ReasonTile56,
          poss: false,
        },
        {
          state: "gepaeck",
          val: this.$store.state.selectedLang.ReasonTile60,
          poss: true,
        },
        {
          state: "sicherkontrolle",
          val: this.$store.state.selectedLang.ReasonTile58,
          poss: false,
        },
        {
          state: "flugsicherung",
          val: this.$store.state.selectedLang.ReasonTile62,
          poss: false,
        },
        {
          state: "checkin",
          val: this.$store.state.selectedLang.ReasonTile54,
          poss: false,
        },
        {
          state: "softwarairport1",
          val: this.$store.state.selectedLang.ReasonTile64,
          poss: false,
        },
        {
          state: "softwarairline",
          val: this.$store.state.selectedLang.ReasonTile66,
          poss: true,
        },
      ],
      casePerReason: [
        {
          state: "streik",
          val: this.$store.state.selectedLang.ReasonTile68,
          poss: true,
        },
        {
          state: "streik",
          val: this.$store.state.selectedLang.ReasonTile68b,
          poss: false,
        },
        {
          state: "personalcorona",
          val: this.$store.state.selectedLang.ReasonTile68a,
          poss: false,
        },
        {
          state: "crewkrank",
          val: this.$store.state.selectedLang.ReasonTile72,
          poss: true,
        },
        {
          state: "crewkranknb",
          val: this.$store.state.selectedLang.ReasonTile74,
          poss: false,
        },
        {
          state: "passagierkrank",
          val: this.$store.state.selectedLang.ReasonTile70,
          poss: false,
        },
      ],
      caseTraReason: [
        {
          state: "sperrunglr",
          val: this.$store.state.selectedLang.ReasonTile76,
          poss: false,
        },
        {
          state: "sperrunglrlb",
          val: this.$store.state.selectedLang.ReasonTile78,
          poss: false,
        },
        {
          state: "kapazi",
          val: this.$store.state.selectedLang.ReasonTile80,
          poss: false,
        },
        {
          state: "anderes",
          val: this.$store.state.selectedLang.ReasonTile82,
          poss: false,
        },
      ],
      selectedInfoCrew: "",
      selectedInfoAirline: "",
      selectedInfoOther: "",
    };
  },
  computed: {
    ...mapState([
      "itemsJN",
      "kiofCla",
      "selectedDiv",
      "pass35",
      "dataFS",
      "dataEP",
      "flN",
      "dateFormatted",
      "labelSL",
      "synFludUnR",
      "noChange",
      "selectedLang",
      "labelDR",
      "firstFlightDelay",
      "wAdditional",
    ]),
    needMoreRes() {
      if (
        this.reasonVal.state == "technik" ||
        this.reasonVal.state == "umwelt" ||
        this.reasonVal.state == "personal" ||
        this.reasonVal.state == "orga" ||
        this.reasonVal.state == "luftsperrung"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showSpecRes() {
      if (
        this.selectedInfoOther.val == "y" ||
        this.selectedInfoCrew.val == "y" ||
        this.selectedInfoAirline.val == "y" ||
        this.selectedInfoOther.val == "n"
      ) {
        return true;
      } else {
        return false;
      }
    },
    needSpecText() {
      if (
        this.problemlayerzwei != "" ||
        this.reasonVal.state == "anderes" ||
        this.kiofCla == "NB"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    async check35() {
      if (this.$refs.reasForm.validate()) {
        this.loading = true;
        this.$store.state.rejectionMessage = this.formatDBText(
          this.$store.state.selectedLang.ReasonTile92a,
          { "this.flN": this.flN }
        );
        if (this.dataFS.isAbsEx) {
          this.setSelectedDiv("32");
        } else {
          if (
            (this.reasonVal.poss && this.reasonVal.state != "anderes" && (this.problemlayerzwei.poss || this.problemlayerzwei == "")) ||
            (this.reasonVal.state == "anderes" &&
              this.firstFlightDelay > 70 &&
              this.kiofCla == "L") ||
            (this.kiofCla == "C" && this.reasonVal.state == "anderes") ||
            this.kiofCla == "NB"
          ) {
            let go4ward = true;
            if (
              (this.dataEP.startAirportSit !== null ||
                this.dataEP.targetAirportSit !== null) &&
              this.reasonVal.state == "anderes" &&
              this.kiofCla != "NB"
            ) {
              let checkArr =
                this.dataEP.startAirportSit !== null
                  ? this.dataEP.startAirportSit
                  : this.dataEP.targetAirportSit;
              let weScore = parseFloat(checkArr.Score);
              if (
                (weScore > 3.3 &&
                  (this.kiofCla == "L" || this.kiofCla == "C")) ||
                (this.kiofCla == "L" &&
                  this.firstFlightDelay < 90 &&
                  weScore > 2.0)
              ) {
                this.$store.state.rejectionMessage = this.formatDBText(
                  this.$store.state.selectedLang.ReasonTile92a,
                  { "this.flN": this.flN }
                );
                go4ward = false;
              }
              let pubAL = dayjs(this.dataFS.times.pubAL);
              let tmw = dayjs(
                pubAL.year() +
                "-" +
                (pubAL.month() + 1) +
                "-" +
                (pubAL.date() + 1)
              );
              if (
                (tmw.diff(pubAL, "minute") <= 150 && weScore > 3.2) ||
                (tmw.diff(pubAL, "minute") <= 120 && weScore > 2.0)
              ) {
                console.log("4");
                this.$store.state.rejectionMessage = this.formatDBText(
                  this.$store.state.selectedLang.ReasonTile92b,
                  { "this.flN": this.flN }
                );
                go4ward = false;
              }
            }

            if (go4ward && this.reasonVal.state == "anderes") {
              await axios
                .post(
                  "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getEuclaimResult.php",
                  {
                    id4ECC: this.dataEP.id4ECC,
                  }
                )
                .then((response) => {
                  if (response.data == "Außergewöhnliche Umstände") {
                    go4ward = false;
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
                .finally();
            }

            if (this.textReason != "") {
              await axios
                .post(
                  "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getBDResult.php",
                  {
                    statement: this.textReason,
                  }
                )
                .then((response) => {
                  this.$store.state.dataEP.forceMajeureCheck = response.data;
                })
                .catch((error) => {
                  console.log(error);
                })
                .finally();
            }

            if (go4ward) {
              if (this.kiofCla == "NB") {
                this.$store.state.dataEP.sCase =
                  this.$store.state.selectedLang.ReasonTile90;
              } else {
                let sCasetemp = "";
                if (this.reasonVal.state == "anderes") {
                  sCasetemp = this.reasonVal.val;
                } else {
                  sCasetemp =
                    this.problemlayerzwei == ""
                      ? this.reasonVal.val
                      : this.reasonVal.val + " - " + this.problemlayerzwei.val;
                }
                this.$store.state.dataEP.sCase = sCasetemp;
              }
              this.$store.state.dataEP.agrund = this.textReason;
              if (this.selectedInfoCrew.val == "y") {
                this.setVar({
                  pos: "selectedInfoCrew",
                  val: this.selectedInfoCrew.state,
                });
                this.$store.state.dataEP.origin = "Crew";
              }
              if (this.selectedInfoAirline.val == "y") {
                this.setVar({
                  pos: "selectedInfoAirline",
                  val: this.selectedInfoAirline.state,
                });
                this.$store.state.dataEP.origin = "Airline";
              }
              if (this.selectedInfoOther.val == "y") {
                this.setVar({
                  pos: "selectedInfoOther",
                  val: this.selectedInfoOther.state,
                });
                this.$store.state.dataEP.origin =
                  this.$store.state.selectedLang.ReasonTile91;
              }
              this.setVar({
                pos: "textReason",
                val: this.textReason,
              });
              this.setVar({ pos: "pass35", val: true });
              this.setSelectedDiv("40");
              this.$nextTick(() => {
                this.goToStep({ vm: this, val: this.selectedDiv });
              });
            } else {
              this.setSelectedDiv("32");
            }
          } else {
            this.setSelectedDiv("32");
          }
        }
        this.$gtag.event("5. Grund mitgeteilt", {
          event_category: "Rechner",
          event_label: "5. Grund mitgeteilt",
        });
        this.loading = false;
      }
    },
    formatDBText(str, values) {
      let result;
      let reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
